import Vue from 'vue'
import Router from 'vue-router'
import service from './services/logacesso'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: '/login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Verify',
          path: '/verify/:link',
          component: () => import('@/views/pages/VerificarEmpresa'),
        },
        {
          name: 'Recover',
          path: '/recover',
          component: () => import('@/views/pages/Recover'),
        },
        {
          name: 'ResetPassword',
          path: '/recover/:link',
          component: () => import('@/views/pages/Recover'),
        },
        {
          name: 'Registrar',
          path: '/registrar',
          component: () => import('@/views/pages/Usuario'),
        },
        {
          name: 'AtivarPerfil',
          path: '/registrar/usuario/:link',
          component: () => import('@/views/pages/Usuario'),
        },
      ],
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Principal',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Editar Perfil',
          path: '/editar-perfil',
          component: () => import('@/views/dashboard/forms/EditProfileForm'),
        },
        {
          name: 'Listar Produtos',
          path: '/lista-produtos',
          component: () => import('@/views/dashboard/forms/ListaProdutosForm'),
        },
        {
          name: 'Carrinho',
          path: '/carrinho',
          component: () => import('@/views/dashboard/forms/CarrinhoForm'),
        },
        {
          name: 'Finalizar Compra',
          path: '/finaliza-compra',
          component: () => import('@/views/dashboard/forms/FinalizaCompraForm'),
        },
        {
          name: 'Meus pedidos',
          path: '/lista-pedido',
          component: () => import('@/views/dashboard/forms/ListaPedidoForm'),
        },
        {
          name: 'Descrição produto',
          path: '/descricao-produto',
          component: () => import('@/views/dashboard/forms/DescricaoProdutoForm'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (localStorage.username && localStorage.tokencontrato) {
    var a = 'undefined'
    // if (navigator && navigator.userAgentData && navigator.userAgentData.platform) {
    //   a = navigator.userAgentData.platform
    // } else
    if (navigator && navigator.appVersion) {
      a = navigator.appVersion
    } else {
      a = navigator.userAgent
    }
    service.logacesso(localStorage.username, localStorage.tokencontrato, to.fullPath, a).then(resposta => {
      // if (resposta.data) {
      //   console.log(resposta.data)
      // }
    })
  }
  next()
})

export default router
